export default __webpack_public_path__ + "static/media/medium-logo.2931748a.svg";